export interface IOptnSrtrValidation {
    rowIndex: number,
    columns: string[],
    errors: string[],
    rowMissingData: boolean
}